// extracted by mini-css-extract-plugin
module.exports = {"stepper":"Stepper_stepper__ZOi2i","text":"Stepper_text__2lGrj"};